"use client";

import { AudioPlayerDownloadStemSplitGroup } from "@/components/audioPlayers/audioPlayerDownloadStemSplitGroup/AudioPlayerDownloadStemSplitGroup";
import { Heading4 } from "@/components/text/Heading4";
import { StemSplitGroupWithAudioNoDates } from "@/types/defs/stemSplit";

export function StemSplitGroupHistory({
  stemSplitGroups,
}: {
  stemSplitGroups: StemSplitGroupWithAudioNoDates[];
}) {
  return (
    <>
      <Heading4 elementType="h2" className="mb-4 mt-6">
        History
      </Heading4>

      <div className="flex h-full flex-col gap-y-4 overflow-auto rounded-3xl p-2 md:max-h-[700px]">
        {stemSplitGroups.map((stemSplitGroup) => (
          <div key={stemSplitGroup.id}>
            <AudioPlayerDownloadStemSplitGroup
              stemSplitGroup={stemSplitGroup}
            />
          </div>
        ))}
      </div>
    </>
  );
}
